<template>
	<c-modal @close="close" :title="'Voorraad importeren'">

		<c-form ref="form" @valid="submit" class="margin-t-40">

            <div>
                <a href="/excel/Template.xlsx" download>Download template</a>
            </div>

		
			<Loader :loading="loading">

				<div class="margin-t-32">
					<c-input
						@change="uploadFile"
						:label="'Bestand'"
						:horizontal="true"
						type="file"
						accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
						name="file"
						ref="file"
						required
					/>
				</div>

			</Loader>

			<p class="color-alert" v-for="error in errors" :key="error">{{error.toString()}}</p>

            <div class="row collapse align-right">
				<div class="columns shrink">
					<c-button class="margin-t-32 margin-b-16 no-margin-b" type="submit">Importeren</c-button>
				</div>
			</div>



		</c-form>

	</c-modal>
</template>

<script>

import Form from '@mixins/Form';
import CModal from '@components/Modal';
import { ValidationError } from '../errors';
import Loader from '@components/loader/Container';

export default {
	mixins: [Form],
	components: {
		CModal, Loader
	},
	data() {
		return {
            file: null,
			errors: {},
			loading: false
		};
	},
    methods: {
        uploadFile(event) {
        	 let files = Array.from(event.target.files);
			 this.file = files[0];
			 this.errors = {};

      	},
        close() {
            this.$emit('close');
        },
        submit(){

            let data = {
				file:  this.file,
			};

			this.errors = {};

			this.loading = true;
            this.$xhr.post('/api/importstock', data).then( ( {result}) => {
					this.close();
				    this.$emit('added');
					this.$refs.form.reset();
					this.loading = false;

					this.$store.dispatch('toast/success', {title: 'Voorraad importeren', text: 'Voorraad is geïmporteerd'});
				}).catch( (e) => {

					if(e instanceof ValidationError) {
						this.errors = e.errors;
					};

					this.loading = false;
					this.$store.dispatch('toast/alert', {title: 'Voorraad importeren', text: 'Voorraad is niet geïmporteerd'});
				});
        }
    },
	mounted() {

	}
}
</script>
